"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWindows = isWindows;
exports.isMacOS = isMacOS;
exports.isLinux = isLinux;
exports.isArm64 = isArm64;
const tslib_1 = require("tslib");
const os = tslib_1.__importStar(require("os"));
function isWindows() {
    return os.type() === "Windows_NT";
}
function isMacOS() {
    return os.type() === "Darwin";
}
function isLinux() {
    return os.type() === "Linux";
}
function isArm64() {
    return os.arch() === "arm64";
}
//# sourceMappingURL=system.js.map